import { buildMikasaClient } from '../../helpers/api'
import { getListingZipcode } from '../listing'

export const getBranding = async (authSettings, address) => {
  const client = await buildMikasaClient(authSettings)

  let endpoint = 'chromebot/branding'
  if (address) {
    const zip = getListingZipcode(address)

    if (zip) {
      endpoint += `?zip=${zip}`
    }
  }

  const response = await client.get(endpoint)

  return response?.data
}
